import React, { useState, useEffect, useRef } from 'react'
import DataGrid from '../../../../components/DataGrid'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { consultar, excluir, get } from '../../../../util/AcessoApi'
import { HeaderCadastro } from '../../../../components/Headers'
import { mostrarToast } from '../../../../components/Toasts'
import { ACOES } from '../../../../util/Enums'
import { getUsuario } from '../../../../util/Configuracoes'
import { mensagens } from '../../../../util/Utilitarios'
import { Alterar, BtnAcaoLink, Excluir, Visualizar } from '../../../../components/Acoes'

const Consulta = props => {
    const [data, setData] = useState([]);
    const target = useRef(null)



    const columns = React.useMemo(
        () => [{
            id: 'consulta-beneficiario',
            columns: [
                {
                    Header: 'Código',
                    accessor: 'id',
                    ordenamento: {
                        tipo: 'numero',
                        ativo: true,
                        modo: 'desc',
                    }
                }, {
                    Header: 'Nome',
                    accessor: 'nome',
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'CPF',
                    accessor: 'cpf',
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Data de Nascimento',
                    accessor: 'data_nascimento',
                    ordenamento: {
                        tipo: 'data'
                    }
                },
                {
                    Header: 'Nome Social',
                    accessor: 'nome_social',
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Número Carteira',
                    accessor: 'numero_carteira',
                    ordenamento: {
                        tipo: 'texto'
                    }
                }, {
                    Header: 'Validade Carteira',
                    accessor: 'validade_carteira',
                    ordenamento: {
                        tipo: 'texto'
                    }
                }, {
                    Header: 'Operadora Saúde',
                    accessor: 'operadora_saude',
                    visivel: false,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'operadora_saude',
                        idColuna: 'operadora_saude_id'
                    }
                }, {
                    Header: 'Data de Registro',
                    accessor: 'data_registro_formatada',
                    ordenamento: {
                        tipo: 'data'
                    }
                }
            ]
        }], []
    );

    const exclusao = propsAcao => {

        const objPermissao = {
            usuario_id: getUsuario().id,
            modulo_id: props.modulo,
            acao_id: ACOES.EXCLUIR
        }
        get('/controleAcesso/permissao', objPermissao).then(function (val) {
            if (val.length) {
                excluir('/faturamento/beneficiario', propsAcao.id,
                    () => {
                        target.current.atualizar();
                        mostrarToast('sucesso', mensagens['sucesso'])
                    },
                    (e) => {
                        if (e.response && e.response.data && e.response.data.erros)
                            e.response.data.erros.forEach((item) => mostrarToast('erro', item))
                        else
                            mostrarToast('erro', mensagens.erro)
                    })
            }
            else
                mostrarToast('erro', mensagens['permissao'])

        }).catch((e) => mostrarToast('erro', mensagens['erro']))
    }

    const maisAcoesObj = [
        (propsAcao) => <Visualizar to={'/faturamento/beneficiario/visualizacao/' + propsAcao.id} />,
        (propsAcao) => <Alterar to={'/faturamento/beneficiario/alteracao/' + propsAcao.id} />,
        (propsAcao) => <Excluir to={'/faturamento/beneficiario/'} action={() => exclusao(propsAcao)} />,
        (propsAcao) => <BtnAcaoLink to={'/faturamento/beneficiario/linhadotempo/' + propsAcao.id} icone={'icon-Time-Window'} texto={'Linha do Tempo'} target={'_blank'} />,
    ]

    return (
        <>
            <div>
                <DataGridAlternativa removerTotalPaginas target={target} data={data} columns={columns} acoesObj={maisAcoesObj} setData={setData} acoes={true} caminhoBase='/faturamento/beneficiario' caminhoConsultaFiltros='/faturamento/beneficiarioPaginacao' modulo={props.modulo} titulo={'Consulta Beneficiário'}
                    tituloLista={'Lista Beneficiário'}
                    urlCadastro='/faturamento/beneficiario/cadastro' icone={'icon-File-ClipboardFileText'} />
            </div>
        </>
    )
}

export default Consulta